import logo from "../../assets/tenants/fsm/logo.png";
import { TenantConfig } from "../types";
import { FsmAboutUsPage } from "./pages/AboutUsPage";
import { FsmPrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { FsmTermsAndConditionsPage } from "./pages/TermsAndConditionsPage";

export const fsmTenant: TenantConfig = {
  id: "fsm",
  companyName: "Societa Sportiva FSM",
  companyDisplayName: "S.S. FSM",
  appName: "fsm_website",
  logo,
  logoAlt: "Logo FSM",
  contactEmail: "infofsm@libero.it",
  contactAddress: "Via Monsignor Dino Torreggiani, 10, Reggio Emilia, Italia",
  registrationLink: null,
  enableCalendar: false,
  theme: {
    navbarBg: "#1d4ed8",
    navbarHoverBg: "#2563eb",
    navbarActiveBg: "#3b82f6",
    navbarText: "#ffffff",
    navbarHoverText: "#ffffff",
    navbarActiveText: "#ffffff",
  },
  pages: {
    AboutUsPage: FsmAboutUsPage,
    PrivacyPolicyPage: FsmPrivacyPolicyPage,
    TermsAndConditionsPage: FsmTermsAndConditionsPage,
  },
};
